import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Rian Bock',
    role: 'Google Review · ★★★★★',
    quote: "Dylan was amazing in my physical therapy process, and was very committed to my recovery, far more so than any other PT I've ever had. He constantly altered my exercises to fit what was best for me, and created new tests and checkpoints in order to gauge how far along I was in my recovery. It's clear that he truly cares about you as a person, not just as his patient. I can't recommend him enough!"
  }, {
    name: 'Ida B.',
    role: 'Google Review · ★★★★★',
    quote: "After months of back pain and a concerning bone density diagnosis, I didn't know where to turn — until I found Dylan. Not only did he resolve my back issues, he helped me meaningfully improve my bone density, something I honestly wasn't sure was possible. The results spoke for themselves: I felt so much stronger and more capable that I decided to keep working with him as a personal trainer. If you're looking for someone who combines real clinical expertise with genuine investment in your progress, Dylan is the one."
  }, {
    name: 'Adam Kommers',
    role: 'Google Review · ★★★★★',
    quote: "Dylan was instrumental throughout my daughter's ACL tear recovery. From pre-hab to re-hab he knew exactly what to focus on on each stage of her recovery. He's a great listener and very detail oriented. He's very personable and above everything he really knows physical therapy inside and out, at all levels. My daughter's back to playing soccer and is stronger than before the injury. Dylan is the best."
  }];
  return <section id="testimonials" className="py-24 bg-white" data-id="element-180">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-181">
        <div className="text-center mb-16" data-id="element-182">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold text-charcoal-950 mb-4" data-id="element-183">
            Client Success
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-charcoal-800 max-w-2xl mx-auto" data-id="element-184">
            Real results from people who committed to the process.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-185">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-offwhite-50 p-8 rounded-2xl border border-offwhite-200 relative" data-id="element-186">
              <QuoteIcon size={40} className="text-amber-500/20 absolute top-6 right-6" data-id="element-187" />
              <p className="text-charcoal-800 text-lg leading-relaxed mb-8 relative z-10 italic" data-id="element-188">
                "{testimonial.quote}"
              </p>
              <div data-id="element-189">
                <h4 className="font-bold text-charcoal-950" data-id="element-190">
                  {testimonial.name}
                </h4>
                <p className="text-sm text-charcoal-500" data-id="element-191">{testimonial.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}